module.exports = __webpack_public_path__ + "static/media/pic_winie2_09.053d39d5.png";